const initialeStates = {
    titel: 'Auswahl',
    link: '',
    url: '',
    steptitel: '',
    buttonActiveStep: true,
    counter: 0,
    data: [
        {briefkasten: [
            {briefkasten_option: [{value: 'ja'}, {value: 'nein'}],
            briefkasten_select: ''
            }
        ]},
        {pforte: [
                {
                pforte_option: [{value: 'ja'},{value: 'nein'}],
                pforte_select: '',
                pforte_width: '',
                pforte_direction: '',
                pforte_direction_option: [
                        {value: 'links nach innen'},{value: 'rechts nach innen'},{value: 'links nach außen'},{value: 'rechts nach außen'}
                    ]
                }
            ]},
        {montage: [
            {
            montage_select: '',
            montage_option: [{value: 'ja'}, {value: 'nein'}]
            }
        ]},
       {editProduct: [
           {
            isEditProduct: false,
            editProductIndex: '',
            editCategory: ''
            }
       ]

       }
    ],
    contact: [
        {
            data: [
                {
                    gender: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    street: '',
                    street_number: '',
                    plz: '',
                    place: '',
                    description: ''

                }
            ]
        },
        {description: ''},
        {uploadfile: [
            {
            image: '',
            file: ''
            }
        ]},
    ]

}

const mainReducer = (states = initialeStates, action) => {
    const copyOfState = {...states};

    switch (action.type) {

        case 'UPDATEHEADER':
            copyOfState.titel = action.ev;
        return copyOfState;

        case 'UPDATEURL':
            let url = action.ev;
            copyOfState.url = url;
        return copyOfState;

        case 'GETSTEPTITEL':
            copyOfState.steptitel = action.ev;
        return copyOfState;

        case 'SETUPDATEBUTTONACTIVESTEPTOFALSE':
            copyOfState.buttonActiveStep = false;
        return copyOfState;

        case 'SETUPDATEBUTTONACTIVESTEPTOTRUE':
            copyOfState.buttonActiveStep = true;
        return copyOfState;

         //update Pforte
         case 'UPDATEPFORTE':
            let pforte_name = action.ev.currentTarget.getAttribute('name');
            if(pforte_name === 'pforteselect') copyOfState.data[1].pforte[0].pforte_select = action.ev.target.value;
            if(pforte_name === 'pfortedirection') copyOfState.data[1].pforte[0].pforte_direction = action.ev.target.value;
            if(pforte_name === 'pfortewidth') copyOfState.data[1].pforte[0].pforte_width = action.ev.target.value;
        return copyOfState;

        //update Briefkasten
        case 'UPDATEBRIEFKASTEN':
            copyOfState.data[0].briefkasten[0].briefkasten_select = action.ev.target.value;
        return copyOfState;

        //update Montage
        case 'UPDATEMONTAGE':
            copyOfState.data[2].montage[0].montage_select = action.ev.target.value;
        return copyOfState;

        //update counter
        case 'UPDATECOUNTER':
            if(action.ev === 'inc') copyOfState.counter = copyOfState.counter +1;
            if(action.ev === 'dec' && copyOfState.counter > 0) copyOfState.counter = copyOfState.counter -1;
        return copyOfState;

        //update description of dimension field
        case 'UPDATEDESCRIPTIONFIELD':
            copyOfState.contact[0].description = action.ev;
        return copyOfState;

        //select upload file
        case 'SELECTUPLOADDATA':
            copyOfState.contact[1].uploadfile[0].image = action.ev.image;
            copyOfState.contact[1].uploadfile[0].file = action.ev.file;
        return copyOfState;

        //delete upload file
        case 'DELETEUPLOADDATA':
            copyOfState.contact[1].uploadfile[0].image = '';
            copyOfState.contact[1].uploadfile[0].file = '';
        return copyOfState;

        //select edit Product
        case 'SELECTEDITPRODUCT':
            let editProductIndex = action.ev.index;
            let editCategory = action.ev.titel;
            copyOfState.data[3].editProduct[0].editProductIndex = editProductIndex;
            copyOfState.data[3].editProduct[0].editCategory = editCategory;
            copyOfState.data[3].editProduct[0].isEditProduct = true;
        return copyOfState;

        //hide edit Product
        case 'HIDEEDITPRODUCT':
            copyOfState.data[3].editProduct[0].isEditProduct = false;
        return copyOfState;

        //update contact data
        case 'UPDATECONTACTDATA':
            let name = action.ev.name;
            let value = action.ev.value;

            switch (name) {
                case 'gender':
                    copyOfState.contact[0].data[0].gender = value;
                break;
                case 'firstname':
                    copyOfState.contact[0].data[0].firstName = value;
                break;
                case 'lastname':
                    copyOfState.contact[0].data[0].lastName = value;
                break;
                case 'email':
                    copyOfState.contact[0].data[0].email = value;
                break;
                case 'phone':
                    copyOfState.contact[0].data[0].phone = value;
                break;
                case 'street':
                    copyOfState.contact[0].data[0].street = value;
                break;
                case 'street_number':
                    copyOfState.contact[0].data[0].street_number = value;
                break;
                case 'plz':
                    copyOfState.contact[0].data[0].plz = value;
                break;
                case 'place':
                    copyOfState.contact[0].data[0].place = value;
                break;
                case 'description':
                    copyOfState.contact[0].data[0].description = value;
                break;
                default:
                    return name;
            }

        return copyOfState;

        default:
            return copyOfState;
    }
}

export default mainReducer;